const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Romance%20manhwa%20style%20cover%20art%2C%20beautiful%20couple%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20Korean%20webtoon%20aesthetic%2C%20elegant%20character%20design%2C%20delicate%20line%20art%2C%20pastel%20coral%20and%20cream%20tones%2C%20romantic%20atmosphere%2C%20professional%20illustration%20quality&width=600&height=800&seq=card-manga-01&orientation=portrait',
    title: '社内相亲',
    category: '韩漫 · 恋爱',
    desc: '职场恋爱天花板，傲娇社长与平凡职员的甜蜜拉扯，下拉式全集免费看',
    chapters: '已完结 · 120话',
    badge: '热度TOP1',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20action%20manhwa%20cover%20art%2C%20powerful%20hunter%20with%20dark%20aura%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20style%2C%20dynamic%20composition%2C%20intense%20atmosphere%2C%20warm%20dark%20tones%2C%20epic%20fantasy%20illustration&width=600&height=800&seq=card-manga-02&orientation=portrait',
    title: '我独自升级',
    category: '韩漫 · 奇幻',
    desc: '从最弱到最强，济州岛突袭篇热血激燃，下拉式畅爽追更',
    chapters: '连载中 · 179话',
    badge: '长期霸榜',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=School%20life%20manhwa%20cover%20art%2C%20beautiful%20girl%20with%20makeup%20transformation%2C%20Korean%20webtoon%20aesthetic%2C%20bright%20and%20cheerful%20mood%2C%20delicate%20illustration%2C%20soft%20warm%20palette%2C%20youthful%20energy&width=600&height=800&seq=card-manga-03&orientation=portrait',
    title: '女神降临',
    category: '韩漫 · 校园',
    desc: '化妆逆袭的校园故事，搞笑又治愈，下拉式全集一口气看完',
    chapters: '已完结 · 216话',
    badge: '口碑佳作',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Comedy%20spy%20manga%20cover%20art%2C%20family%20with%20secret%20identities%2C%20Japanese%20manga%20style%2C%20playful%20and%20warm%20atmosphere%2C%20clean%20line%20art%2C%20soft%20colors%2C%20heartwarming%20family%20theme&width=600&height=800&seq=card-manga-04&orientation=portrait',
    title: '间谍过家家',
    category: '日漫 · 喜剧',
    desc: '伪装家庭的温馨日常，安妮亚太可爱了，下拉式日漫全集上线',
    chapters: '连载中 · 88话',
    badge: '日漫精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20royalty%20manhwa%20cover%20art%2C%20beautiful%20princess%20in%20ornate%20dress%2C%20Korean%20webtoon%20style%2C%20dreamy%20atmosphere%2C%20soft%20golden%20lighting%2C%20elegant%20composition%2C%20fairy%20tale%20aesthetic&width=600&height=800&seq=card-manga-05&orientation=portrait',
    title: '某天成为公主',
    category: '韩漫 · 穿越',
    desc: '穿越成公主的奇妙冒险，画风绝美剧情上头，下拉式畅读全集',
    chapters: '已完结 · 132话',
    badge: '穿越必看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romance%20drama%20manhwa%20cover%20art%2C%20couple%20in%20emotional%20moment%2C%20Korean%20webtoon%20aesthetic%2C%20soft%20warm%20lighting%2C%20tender%20atmosphere%2C%20delicate%20illustration%2C%20melancholic%20yet%20beautiful%20mood&width=600&height=800&seq=card-manga-06&orientation=portrait',
    title: '她的私生活',
    category: '韩漫 · 恋爱',
    desc: '追星站姐的双面人生，甜中带虐，下拉式全集免费阅读',
    chapters: '已完结 · 98话',
    badge: '本周热门',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Action%20fantasy%20manga%20cover%20art%2C%20warrior%20in%20epic%20battle%20pose%2C%20Japanese%20manga%20style%2C%20dramatic%20lighting%2C%20intense%20atmosphere%2C%20warm%20dark%20tones%2C%20powerful%20illustration&width=600&height=800&seq=card-manga-07&orientation=portrait',
    title: '鬼灭之刃',
    category: '日漫 · 热血',
    desc: '炭治郎的灭鬼之路，日漫巅峰之作，下拉式全集沉浸体验',
    chapters: '已完结 · 205话',
    badge: '经典必读',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式平台编辑精选，品质保证</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
          {cards.map((card, i) => (
            <div
              key={i}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 flex flex-col"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {card.badge}
                  </span>
                </div>
              </div>
              <div className="p-3 flex-1 flex flex-col">
                <h3 className="text-sm font-heading text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {card.title}
                </h3>
                <p className="text-[11px] text-foreground-400 mt-0.5">{card.category}</p>
                <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed line-clamp-2 flex-1">{card.desc}</p>
                <p className="text-[11px] text-foreground-400 mt-2 whitespace-nowrap">{card.chapters}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}